import styled from 'styles/styled';

export const TournamentRank = styled.ul`
  padding: 0 17px 0 20px;
  max-height: calc(100% - 24px);
  overflow-y: scroll;
  margin-right: 5px;
  @media (max-width: 1020px) {
    padding: 4px 20px 0px 15px;
    max-height: 100%;
  }
`;

export const TournamentList = styled.li`
  list-style: none;
  font-size: 12px;
  color: #EFEFEF;
  font-weight: 700;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  &:first-child {
    margin-top: 4px;
  }
  .AmountDetails {
    margin-top: 2px;
  }
  &.is_me {
    background-color: rgba(82, 211, 129, 0.06);
    border-color: rgba(82, 211, 129, 0.18);
  }
  @media (max-width: 1020px) {
    margin-bottom: 10px;
  }
  @media (max-width: 720px) {
    font-size: 10px;
  }
`;

export const Rank = styled.h6`
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  min-width: 18px;
  @media (max-width: 720px) {
    font-size: 10px;
    min-width: 16px;
  }
`;

export const WrappList = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TournamentBelt = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NickName = styled.h6`
  font-size: 12px;
  font-weight: 700;
  max-width: 140px;
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 720px) {
    font-size: 10px;
  }
`;

export const Percent = styled.h6`
  font-size: 11px;
  font-weight: 500;
  &.up_state {
    color: #52D381;
  }
  &.down_state {
    color: #FF6782;
  }
  @media (max-width: 720px) {
    font-size: 10px;
  }
`;

export const Amount = styled.h6`
  font-size: 11px;
  color: #52D381;
  font-weight: 700;
  @media (max-width: 720px) {
    font-size: 10px;
  }
  &.up_state {
    color: #52D381;
  }
  &.down_state {
    color: #FF6782;
  }
`;
